import React from "react";

/*
 * TECHNOLOGY DATA
 */
const technologies = [
  {
    name: "React",
    category: "Frontend",
    color: "#61DAFB",
    icon: "https://cdn.simpleicons.org/react/61DAFB",
  },
  {
    name: "Next.js",
    category: "Framework",
    color: "#000000",
    icon: "https://cdn.simpleicons.org/nextdotjs/000000",
  },
  {
    name: "Tailwind CSS",
    category: "CSS",
    color: "#06B6D4",
    icon: "https://cdn.simpleicons.org/tailwindcss/06B6D4",
  },
  {
    name: "TypeScript",
    category: "Language",
    color: "#3178C6",
    icon: "https://cdn.simpleicons.org/typescript/3178C6",
  },
  {
    name: "JavaScript",
    category: "Language",
    color: "#F7DF1E",
    icon: "https://cdn.simpleicons.org/javascript/F7DF1E",
  },
  {
    name: "Java",
    category: "Backend",
    color: "#EA2D2E",
    icon: "https://cdn.simpleicons.org/openjdk/EA2D2E",
  },
  {
    name: "Spring Boot",
    category: "Framework",
    color: "#6DB33F",
    icon: "https://cdn.simpleicons.org/spring/6DB33F",
  },
  {
    name: "Node.js",
    category: "Runtime",
    color: "#339933",
    icon: "https://cdn.simpleicons.org/nodedotjs/339933",
  },
  {
    name: "Express",
    category: "API",
    color: "#000000",
    icon: "https://cdn.simpleicons.org/express/000000",
  },
  {
    name: "MongoDB",
    category: "Database",
    color: "#47A248",
    icon: "https://cdn.simpleicons.org/mongodb/47A248",
  },
  {
    name: "MySQL",
    category: "Database",
    color: "#4479A1",
    icon: "https://cdn.simpleicons.org/mysql/4479A1",
  },
  {
    name: "PostgreSQL",
    category: "Database",
    color: "#4169E1",
    icon: "https://cdn.simpleicons.org/postgresql/4169E1",
  },
  {
    name: "Redis",
    category: "Cache",
    color: "#DC382D",
    icon: "https://cdn.simpleicons.org/redis/DC382D",
  },
  {
    name: "Docker",
    category: "DevOps",
    color: "#2496ED",
    icon: "https://cdn.simpleicons.org/docker/2496ED",
  },
  {
    name: "AWS",
    category: "Cloud",
    color: "#FF9900",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
  },
  {
    name: "Git",
    category: "Version Control",
    color: "#F05032",
    icon: "https://cdn.simpleicons.org/git/F05032",
  },
  {
    name: "GitHub",
    category: "Repository",
    color: "#181717",
    icon: "https://cdn.simpleicons.org/github/181717",
  },
  {
    name: "Nginx",
    category: "Server",
    color: "#009639",
    icon: "https://cdn.simpleicons.org/nginx/009639",
  },
  {
    name: "CI/CD",
    category: "Automation",
    color: "#C8762A",
    icon: "https://cdn.simpleicons.org/githubactions/2088FF",
  },
  {
    name: "Microservices",
    category: "Architecture",
    color: "#C8762A",
    icon: "https://cdn.simpleicons.org/kubernetes/326CE5",
  },
];

/*
 * SPLIT TECHNOLOGIES INTO THREE ROWS
 */
const row1 = technologies.slice(0, 7);
const row2 = technologies.slice(7, 14);
const row3 = technologies.slice(14);

/*
 * TECHNOLOGY CARD
 */
const TechCard = ({ tech }) => {
  return (
    <div
      className="
        group
        flex
        min-w-[175px]
        items-center
        gap-3
        rounded-2xl
        border
        border-stone-200
        bg-white/95
        px-3
        py-3
        shadow-sm
        backdrop-blur-xl
        transition-all
        duration-300

        sm:min-w-[210px]
        sm:gap-4
        sm:rounded-3xl
        sm:px-5
        sm:py-4
        sm:shadow-md

        lg:min-w-[240px]
        lg:px-6

        lg:hover:-translate-y-2
        lg:hover:border-[#C8762A]
        lg:hover:shadow-[0_20px_50px_rgba(200,118,42,0.22)]
      "
    >
      {/* Icon */}
      <div
        className="
          flex
          h-11
          w-11
          shrink-0
          items-center
          justify-center
          rounded-xl

          sm:h-12
          sm:w-12
          sm:rounded-2xl

          lg:h-14
          lg:w-14
        "
        style={{
          background: `${tech.color}15`,
        }}
      >
        <img
          src={tech.icon}
          alt={tech.name}
          loading="lazy"
          className="
            h-6
            w-6
            object-contain

            sm:h-7
            sm:w-7

            lg:h-8
            lg:w-8
          "
        />
      </div>

      {/* Technology Information */}
      <div className="min-w-0">
        <p
          className="
            truncate
            text-sm
            font-semibold
            text-[#1A1714]

            sm:text-base

            lg:text-lg
          "
        >
          {tech.name}
        </p>

        <p
          className="
            mt-0.5
            truncate
            text-[11px]
            text-stone-500

            sm:text-xs

            lg:text-sm
          "
        >
          {tech.category}
        </p>
      </div>
    </div>
  );
};

/*
 * MARQUEE ROW
 */
const MarqueeRow = ({
  items,
  direction = "left",
  speed = 35,
}) => {
  return (
    <div className="overflow-hidden py-1.5 sm:py-2 lg:py-3">
      <div
        className={`
          flex
          w-max
          gap-3

          sm:gap-4

          lg:gap-6

          ${
            direction === "left"
              ? "animate-marquee-left"
              : "animate-marquee-right"
          }
        `}
        style={{
          animationDuration: `${speed}s`,
        }}
      >
        {[...items, ...items].map((tech, index) => (
          <TechCard
            key={`${tech.name}-${index}`}
            tech={tech}
          />
        ))}
      </div>
    </div>
  );
};

/*
 * STAT CARD
 */
const StatCard = ({ value, label }) => {
  return (
    <div
      className="
        group
        min-w-0
        rounded-xl
        border
        border-stone-200
        bg-white
        px-2
        py-4
        text-center
        shadow-sm
        transition-all
        duration-300

        sm:px-4
        sm:py-5

        lg:hover:-translate-y-1
        lg:hover:shadow-lg
      "
    >
      <h3
        className="
          break-words
          text-xl
          font-bold
          leading-tight
          text-[#C8762A]

          sm:text-2xl

          md:text-3xl
        "
      >
        {value}
      </h3>

      <div className="mx-auto my-2 h-0.5 w-6 rounded-full bg-[#C8762A]/30 sm:w-8" />

      <p
        className="
          break-words
          text-[9px]
          font-medium
          uppercase
          leading-4
          tracking-wide
          text-stone-600

          sm:text-[10px]

          md:text-xs
        "
      >
        {label}
      </p>
    </div>
  );
};

/*
 * MAIN COMPONENT
 */
export default function TechStack() {
  return (
    <section
      id="technology"
      className="
        relative
        scroll-mt-24
        overflow-hidden
        bg-[#FAF8F4]
        py-12

        sm:py-16

        lg:py-20
      "
    >
      {/* Background Blur Effects */}
      <div className="pointer-events-none absolute inset-0">
        <div
          className="
            absolute
            -left-24
            top-10
            h-52
            w-52
            rounded-full
            bg-[#C8762A]/10
            blur-[90px]

            sm:h-64
            sm:w-64

            lg:-left-32
            lg:h-80
            lg:w-80
            lg:blur-[120px]
          "
        />

        <div
          className="
            absolute
            right-0
            top-0
            h-64
            w-64
            rounded-full
            bg-blue-200/20
            blur-[100px]

            lg:h-[450px]
            lg:w-[450px]
            lg:blur-[150px]
          "
        />

        <div
          className="
            absolute
            bottom-0
            left-1/2
            h-64
            w-64
            -translate-x-1/2
            rounded-full
            bg-amber-100/30
            blur-[100px]

            lg:h-[400px]
            lg:w-[400px]
            lg:blur-[140px]
          "
        />
      </div>

      <div className="relative mx-auto w-full max-w-7xl">
        {/* Heading */}
        <div className="mb-8 px-5 text-center sm:mb-10 sm:px-6 lg:mb-14">
          <span
            className="
              inline-flex
              rounded-full
              border
              border-[#F1D5B6]
              bg-[#FBF0E2]
              px-3
              py-1.5
              text-[9px]
              font-semibold
              uppercase
              tracking-[0.18em]
              text-[#C8762A]

              sm:px-4
              sm:text-[10px]
              sm:tracking-[0.22em]
            "
          >
            Technology Stack
          </span>

          <h2
            className="
              mt-4
              text-[28px]
              font-bold
              leading-[1.15]
              text-[#1A1714]

              sm:mt-5
              sm:text-4xl

              md:text-5xl

              lg:mt-6
            "
          >
            Built With
            <br />

            <span className="italic text-[#C8762A]">
              Modern Technologies
            </span>
          </h2>

          <p
            className="
              mx-auto
              mt-4
              max-w-[340px]
              text-sm
              leading-6
              text-stone-600

              sm:mt-5
              sm:max-w-2xl
              sm:text-base
              sm:leading-7
            "
          >
            We combine modern frontend frameworks, enterprise backend
            technologies, scalable cloud infrastructure, and DevOps best
            practices to build reliable digital products.
          </p>
        </div>

        {/* Marquee */}
        <div className="relative">
          {/* Left Fade */}
          <div
            className="
              pointer-events-none
              absolute
              left-0
              top-0
              z-20
              h-full
              w-5
              bg-gradient-to-r
              from-[#FAF8F4]
              to-transparent

              sm:w-10

              lg:w-20
            "
          />

          {/* Right Fade */}
          <div
            className="
              pointer-events-none
              absolute
              right-0
              top-0
              z-20
              h-full
              w-5
              bg-gradient-to-l
              from-[#FAF8F4]
              to-transparent

              sm:w-10

              lg:w-20
            "
          />

          <MarqueeRow
            items={row1}
            direction="left"
            speed={28}
          />

          <MarqueeRow
            items={row2}
            direction="right"
            speed={34}
          />

          <MarqueeRow
            items={row3}
            direction="left"
            speed={40}
          />
        </div>

        {/* Stats */}
        <div
          className="
            mt-8
            grid
            grid-cols-2
            gap-3
            px-4

            sm:mt-10
            sm:gap-4
            sm:px-6

            md:grid-cols-4

            lg:mt-12
          "
        >
          <StatCard
            value="20+"
            label="Technologies"
          />

          <StatCard
            value="100%"
            label="Responsive"
          />

          <StatCard
            value="Fast"
            label="Performance"
          />

          <StatCard
            value="Secure"
            label="Architecture"
          />
        </div>
      </div>
    </section>
  );
}